export enum EBrowserType {
  CHROME = 'Chrome',
  EDGE = 'Edge',
  FIREFOX = 'Firefox',
  IE = 'IE',
  OPERA = 'Opera',
  SAFARI = 'Safari',
}
